module.exports = __webpack_public_path__ + "img/teacherNo3.47dda211.png";